import { ReduxAsyncActionsService } from '../../services/ReduxAsyncActions.service';
import type { WrappedReducer } from '../../types/ReduxAsyncActions.types';
import type { UsageAction } from './actions';
import { FETCH_MAU_COUNT_DATA, FETCH_MAU_LIMIT, FETCH_MAU_OVERAGE_COST } from './actions';
import { INIT_STATE } from './constants';
import type { UsageState } from './types';

const Handler = (state: WrappedReducer<UsageState>, action: UsageAction): WrappedReducer<UsageState> => {
  switch (action.type) {
    case FETCH_MAU_LIMIT.response:
      return {
        ...state,
        loading: false,
        usageData: {
          ...state.usageData,
          mauLimit: action.data,
        },
      };
    case FETCH_MAU_OVERAGE_COST.response:
      return {
        ...state,
        loading: false,
        usageData: {
          ...state.usageData,
          mauOverageCost: action.data?.data,
        },
      };
    case FETCH_MAU_COUNT_DATA.response:
      return {
        ...state,
        loading: false,
        countData: action.data?.data,
      };
    default:
      return state;
  }
};

const Usage = ReduxAsyncActionsService.wrapReducer(INIT_STATE, Handler, {
  request: [FETCH_MAU_LIMIT, FETCH_MAU_OVERAGE_COST, FETCH_MAU_COUNT_DATA],
  error: [FETCH_MAU_LIMIT, FETCH_MAU_OVERAGE_COST, FETCH_MAU_COUNT_DATA],
});

export default Usage;
